
const CommitmentSection = () => {
  const commitments = [
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description: 'Prioritizing eco-friendly chemistries that reduce environmental footprint while maintaining superior performance.',
      image: 'https://public.readdy.ai/ai/img_res/70682b2c774feb8d14c10979093bb06e.jpg'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'Strict testing and quality control across all stages of production, ensuring consistent excellence.',
      image: 'https://readdy.ai/api/search-image?query=Golden%20Black%20quality%20control%20laboratory%20with%20technicians%20performing%20chemical%20analysis%2C%20advanced%20testing%20equipment%20and%20quality%20assurance%20protocols%2C%20professional%20lab%20environment%20with%20Golden%20Black%20branded%20testing%20stations%20and%20certification%20processes&width=500&height=350&seq=quality&orientation=landscape'
    },
    {
      icon: 'ri-microscope-line',
      title: 'R&D Excellence',
      description: 'Continuous investment in research and innovation to develop next-generation chemical solutions.',
      image: 'https://readdy.ai/api/search-image?query=Golden Black research and development laboratory with scientists conducting advanced chemical research, cutting-edge analytical instruments and innovation equipment, modern R&D facility with Golden Black branding and research excellence focus&width=500&height=350&seq=research&orientation=landscape'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Reach',
      description: 'Supporting clients across diverse sectors and geographies with our comprehensive chemical solutions.',
      image: 'https://readdy.ai/api/search-image?query=Golden%20Black%20international%20manufacturing%20and%20distribution%20network%2C%20global%20chemical%20production%20facilities%20with%20world%20map%20and%20shipping%20containers%2C%20international%20operations%20with%20Golden%20Black%20branded%20logistics%20and%20global%20reach%20capabilities&width=500&height=350&seq=global&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            🌱 Our Commitment
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Golden Black is dedicated to delivering excellence through sustainable practices, 
            rigorous quality standards, and continuous innovation in chemical manufacturing.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {commitments.map((commitment, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg">
              <img 
                src={commitment.image}
                alt={`Golden Black ${commitment.title}`}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mr-4">
                    <i className={`${commitment.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">{commitment.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{commitment.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Manufacturing Excellence Showcase */}
        <div className="mt-20 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-white">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Manufacturing Excellence</h3>
              <p className="text-xl mb-6 text-teal-100">
                Our state-of-the-art production facilities combine advanced technology with 
                expert craftsmanship to deliver superior chemical solutions.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-300 text-xl mr-3"></i>
                  <span>ISO-certified manufacturing processes</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-300 text-xl mr-3"></i>
                  <span>Advanced automation and quality control</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-300 text-xl mr-3"></i>
                  <span>Scalable production capabilities</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-300 text-xl mr-3"></i>
                  <span>Environmental compliance and safety</span>
                </li>
              </ul>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Golden%20Black%20chemical%20manufacturing%20plant%20exterior%20with%20company%20logo%20prominently%20displayed%2C%20modern%20industrial%20facility%20with%20advanced%20chemical%20production%20equipment%2C%20professional%20manufacturing%20complex%20with%20Golden%20Black%20branding%20and%20industrial%20excellence&width=600&height=400&seq=facility&orientation=landscape"
                alt="Golden Black Manufacturing Facility"
                className="w-full h-80 object-cover object-top rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommitmentSection;
